import React from "react";
import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import EditDeleteButton from "components/table/EditDeleteButton";
import useToggleDrawer from "hooks/useToggleDrawer";

const TrustedCompanyTable = ({ companyData, hideEdit, hideDelete }) => {
  const {
    handleModalOpen,
    handleUpdate,
    isSubmitting,
  } = useToggleDrawer();

  const imageBaseUrl = (
    process.env.REACT_APP_API_IMAGE_URL || ""
  ).replace(/\/+$/, "");

  const getImageUrl = (path) => {
    if (!path) return "";

    if (/^https?:\/\//i.test(path)) {
      return path;
    }

    return `${imageBaseUrl}/${path.replace(/^\/+/, "")}`;
  };

  return (
    <TableBody>
      {companyData?.map((company, index) => (
        <TableRow key={company.id}>
          <TableCell className="text-center text-xs">
            {index + 1}
          </TableCell>

          <TableCell className="text-center text-xs font-medium">
            {company.company_name || "-"}
          </TableCell>

          <TableCell className="text-center">
            {company.company_logo ? (
              <div className="flex justify-center">
                <img
                  src={getImageUrl(company.company_logo)}
                  alt={`${company.company_name || "Company"} logo`}
                  className="w-16 h-16 object-contain rounded-md border border-gray-200 p-1"
                  onError={(event) => {
                    event.currentTarget.style.display = "none";
                  }}
                />
              </div>
            ) : (
              <span className="text-xs text-gray-500">No logo</span>
            )}
          </TableCell>

          <TableCell className="text-sm text-center">
            <div className="flex justify-center">
              <EditDeleteButton
                id={company.id}
                isSubmitting={isSubmitting}
                handleUpdate={handleUpdate}
                handleModalOpen={handleModalOpen}
                hideEdit={hideEdit}
                hideDelete={hideDelete}
              />
            </div>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  );
};

export default TrustedCompanyTable;